import * as angular from 'angular';
import { IRequestService } from '../request.service';
import { IDateRangeService } from '../../services';

export interface ImissingInputService {
    getPercentage(): angular.IPromise<number>;
    getPercentageEvolution(): angular.IPromise<{ [date: string]: number }>;
    getCountPerConnectionPoint(): angular.IPromise<{ [guid: string]: number }>;
    getCountPerTag(): angular.IPromise<{ [guid: string]: number }>;
    getCountPerTagForConnectionPoint(connectionPointGuid: string): angular.IPromise<{ [guid: string]: number }>;
}

export class MissingInputService implements ImissingInputService {
    static serviceId = 'missingInputService';

    private _controllerUrl = 'missingInput/';

    static $inject = ['requestService', 'dateRangeService'];
    constructor(private _requestService: IRequestService,
        private _dateRangeService: IDateRangeService) {
    }

    getPercentage(): angular.IPromise<number> {
        const beginDate = this._dateRangeService.beginDate() as string;
        const endDate = this._dateRangeService.endDate() as string;
        return this._requestService.getAtV1(`${this._controllerUrl}getPercentage`, { beginDate, endDate });
    }

    getPercentageEvolution(): angular.IPromise<{ [date: string]: number }> {
        const beginDate = this._dateRangeService.beginDate() as string;
        const endDate = this._dateRangeService.endDate() as string;
        return this._requestService.getAtV1(`${this._controllerUrl}getPercentagePerDate`, { beginDate, endDate });
    }

    getCountPerConnectionPoint(): angular.IPromise<{ [guid: string]: number; }> {
        const beginDate = this._dateRangeService.beginDate() as string;
        const endDate = this._dateRangeService.endDate() as string;
        return this._requestService.getAtV1(`${this._controllerUrl}getCountPerConnectionPoint`, { beginDate, endDate });
    }

    getCountPerTag(): angular.IPromise<{ [guid: string]: number; }> {
        const beginDate = this._dateRangeService.beginDate() as string;
        const endDate = this._dateRangeService.endDate() as string;
        return this._requestService.getAtV1(`${this._controllerUrl}getCountPerTag`, { beginDate, endDate });
    }

    getCountPerTagForConnectionPoint(connectionPointGuid: string): angular.IPromise<{ [guid: string]: number }> {
        const beginDate = this._dateRangeService.beginDate() as string;
        const endDate = this._dateRangeService.endDate() as string;
        return this._requestService.getAtV1(`${this._controllerUrl}getCountPerTagForConnectionPoint`, { beginDate, endDate, connectionPointGuid });
    }
}